// import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
// import { User } from './userType/User';

// interface UserContextType {
//   user: User | null;
//   setUser: (user: User | null) => void;
//   isAdmin: boolean;
// }

// const UserContext = createContext<UserContextType | undefined>(undefined);


// export const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
//   const [user, setUser] = useState<User | null>(null);
//   const [isAdmin, setIsAdmin] = useState<boolean>(false);

//   const setUserAndCheckRole = (user: User | null) => {
//     setUser(user);
//     setIsAdmin(user?.role.type.toLowerCase() == 'admin');
//   };

//   useEffect(() => {
//     const storedUser = localStorage.getItem('user');
//     if (storedUser) {
//       const parsedUser = JSON.parse(storedUser) as User;
//       setUser(parsedUser);
//       setIsAdmin(parsedUser.role.type.toLowerCase() == 'admin');
//     }
//   }, []);

//   return (
//     <UserContext.Provider value={{ user, setUser: setUserAndCheckRole, isAdmin }}>
//       {children}
//     </UserContext.Provider>
//   );
// };


// export const useUserContext = (): UserContextType => {
//   const context = useContext(UserContext);
//   if (!context) {
//     throw new Error('Error in user context');
//   }
//   return context;
// };

//=========================================================

// import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
// import axios from 'axios';
// import { User } from './userType/User';
// import axiosInstance from '../../services/axios';

// interface UserContextType {
//   user: User | null;
//   setUser: (user: User | null) => void;
//   isAdmin: boolean;
//   refreshUser: () => Promise<void>; // added
// }

// const UserContext = createContext<UserContextType | undefined>(undefined);

// export const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
//   const [user, setUser] = useState<User | null>(null);
//   const [isAdmin, setIsAdmin] = useState<boolean>(false);

//   const setUserAndCheckRole = (user: User | null) => {
//     setUser(user);
//     setIsAdmin(user?.role.type.toLowerCase() === 'admin');
//   };

//   useEffect(() => {
//     const fetchUser = async () => {
//       try {
//         const response = await axiosInstance.get<User>('/auth/me');
//         const fetchedUser = response.data;
//         setUserAndCheckRole(fetchedUser);
//       } catch (error) {
//         console.error('Failed to fetch user:', error);
//         setUser(null);
//         setIsAdmin(false);
//       }
//     };

//     fetchUser();
//   }, []);

//   return (
//     <UserContext.Provider value={{ user, setUser: setUserAndCheckRole, isAdmin,refreshUser:fetchUser() }}>
//       {children}
//     </UserContext.Provider>
//   );
// };

// export const useUserContext = (): UserContextType => {
//   const context = useContext(UserContext);
//   if (!context) {
//     throw new Error('Error in user context');
//   }
//   return context;
// };


import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import axiosInstance from '../../services/axios';
import { User } from './userType/User';

interface UserContextType {
  user: User | null;
  setUser: (user: User | null) => void;
  isAdmin: boolean;
  refreshUser: () => Promise<void>;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);

  const setUserAndCheckRole = (user: User | null) => {
    setUser(user);
    setIsAdmin(user?.role.type.toLowerCase() === 'admin');
  };

  const fetchUser = async () => {
    try {
      const response = await axiosInstance.get<User>('/auth/me');
      const fetchedUser = response.data;
      setUserAndCheckRole(fetchedUser);
    } catch (error) {
      console.error('Failed to fetch user:', error);
      setUser(null);
      setIsAdmin(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser: setUserAndCheckRole, isAdmin, refreshUser: fetchUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = (): UserContextType => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  return context;
};
